import { RootState } from 'handlers';

export const getShiftImpactState = (state: RootState) => state.shiftImpact;
